import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-gradient-to-b from-emerald-50 to-white pt-8 pb-16 md:pt-12 md:pb-24 overflow-hidden" data-id="element-91">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-92">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-93">
          {/* Copy Column */}
          <div className="w-full md:w-1/2 z-10" data-id="element-94">
            <div className="inline-block bg-emerald-100 text-emerald-800 px-4 py-1 rounded-full text-sm font-bold mb-6 uppercase tracking-wide" data-id="element-95">
              Para mujeres de 60+ años
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 leading-tight mb-6" data-id="element-96">
              ¿Rodillas de 80 años?{' '}
              <span className="text-emerald-700" data-id="element-97">Recupéralas en 21 días</span>{' '}
              con el Método de la Silla.
            </h1>

            <p className="text-xl md:text-2xl text-slate-700 mb-8 leading-relaxed" data-id="element-98">
              Sin salir de casa. Sin gimnasio. Sin impacto. Fortalece tus
              piernas mientras ves tu novela favorita.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-99">
              <Button size="xl" fullWidth withIcon onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-100">
                SÍ, QUIERO CAMINAR SIN DOLOR
              </Button>
            </div>

            <div className="flex items-center gap-2 text-slate-600 text-sm font-medium" data-id="element-101">
              <ShieldCheck className="h-5 w-5 text-emerald-600" data-id="element-102" />
              <span data-id="element-103">Garantía de devolución de 30 días</span>
            </div>
          </div>

          {/* Image Column */}
          <div className="w-full md:w-1/2 relative" data-id="element-104">
            <div className="absolute inset-0 bg-amber-200 rounded-full blur-3xl opacity-30 transform translate-x-10 translate-y-10" data-id="element-105"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iiW3UxfoZG3o1ZJkNarvVS/heyloid1.png" alt="Rodillas Jóvenes: El Método de la Silla en tablet" className="relative z-10 w-full h-auto drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-106" />

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 md:bottom-10 md:-left-10 bg-white p-4 rounded-xl shadow-xl z-20 max-w-xs border-l-4 border-amber-500" data-id="element-107">
              <div className="flex items-start gap-3" data-id="element-108">
                <CheckCircle2 className="h-8 w-8 text-green-500 flex-shrink-0" data-id="element-109" />
                <div data-id="element-110">
                  <p className="font-bold text-slate-900" data-id="element-111">Fácil de seguir</p>
                  <p className="text-sm text-slate-600" data-id="element-112">
                    Diseñado para hacer sentada, sin riesgo de caídas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}